<template>
  <v-btn v-show="isShow" @click="toTop" fab dark color="black">
    <v-icon large>arrow_upward</v-icon>
  </v-btn>
</template>

<script>
export default {
  data () {
    return {
      isShow: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    toTop () {
      let target = document.getElementById('headMenu')
      this.$SmoothScroll(target, 500, undefined, undefined, 'y')
    },
    handleScroll () {
      if (window.scrollY > 200) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    }
  }
}
</script>

<style>

</style>
